var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilAltOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 3.33333H4.00008C3.64646 3.33333 3.30732 3.47381 3.05727 3.72385C2.80722 3.9739 2.66675 4.31304 2.66675 4.66666V12C2.66675 12.3536 2.80722 12.6928 3.05727 12.9428C3.30732 13.1929 3.64646 13.3333 4.00008 13.3333H11.3334C11.687 13.3333 12.0262 13.1929 12.2762 12.9428C12.5263 12.6928 12.6667 12.3536 12.6667 12V8.66666M11.7241 2.39066C11.8471 2.26332 11.9942 2.16174 12.1569 2.09186C12.3195 2.02198 12.4945 1.9852 12.6715 1.98366C12.8486 1.98212 13.0242 2.01586 13.188 2.0829C13.3519 2.14994 13.5008 2.24895 13.6259 2.37414C13.7511 2.49933 13.8501 2.6482 13.9172 2.81206C13.9842 2.97592 14.018 3.15149 14.0164 3.32853C14.0149 3.50557 13.9781 3.68053 13.9082 3.8432C13.8383 4.00587 13.7368 4.153 13.6094 4.276L7.88541 10H6.00008V8.11466L11.7241 2.39066Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAltOutline);
export default __webpack_public_path__ + "static/media/PencilAltOutline.ed32ad20cd5825e0bc8d9c8c304ff52d.svg";
export { ForwardRef as ReactComponent };